import { OrderEventsOverview } from 'projects/flow-gui-access/views/middlewares/orderevents'

module.exports = [
  {
    path: '/events',
    exact: true,
    component: OrderEventsOverview
  }
]



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/routes/orderevents.js